"use strict";

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var E = require("../expressions");

var Err = require("../util/Errors");

var Transformation_1 = require("../Transformation");

var sharedEvaluators = {
  term: function term(expr, mapping) {
    return expr;
  },
  variable: function variable(expr, mapping) {
    var term = mapping.get(expr.name);

    if (!term) {
      throw new Err.UnboundVariableError(expr.name, mapping);
    }

    return Transformation_1.transformRDFTermUnsafe(term);
  }
};

var AsyncRecursiveEvaluator =
/*#__PURE__*/
function () {
  function AsyncRecursiveEvaluator(context) {
    var _this$subEvaluators;

    _classCallCheck(this, AsyncRecursiveEvaluator);

    this.context = context;
    this.subEvaluators = (_this$subEvaluators = {}, _defineProperty(_this$subEvaluators, E.ExpressionType.Term, sharedEvaluators.term), _defineProperty(_this$subEvaluators, E.ExpressionType.Variable, sharedEvaluators.variable), _defineProperty(_this$subEvaluators, E.ExpressionType.Operator, this.evalOperator), _defineProperty(_this$subEvaluators, E.ExpressionType.SpecialOperator, this.evalSpecialOperator), _defineProperty(_this$subEvaluators, E.ExpressionType.Named, this.evalNamed), _defineProperty(_this$subEvaluators, E.ExpressionType.Existence, this.evalExistence), _defineProperty(_this$subEvaluators, E.ExpressionType.Aggregate, this.evalAggregate), _this$subEvaluators);
  }

  _createClass(AsyncRecursiveEvaluator, [{
    key: "evaluate",
    value: function () {
      var _evaluate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(expr, mapping) {
        var evaluator;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                evaluator = this.subEvaluators[expr.expressionType];

                if (evaluator) {
                  _context.next = 3;
                  break;
                }

                throw new Err.InvalidExpressionType(expr);

              case 3:
                return _context.abrupt("return", evaluator.bind(this)(expr, mapping));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function evaluate(_x, _x2) {
        return _evaluate.apply(this, arguments);
      }

      return evaluate;
    }()
  }, {
    key: "evalOperator",
    value: function () {
      var _evalOperator = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(expr, mapping) {
        var _this = this;

        var argPromises, argResults;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                argPromises = expr.args.map(function (arg) {
                  return _this.evaluate(arg, mapping);
                });
                _context2.next = 3;
                return Promise.all(argPromises);

              case 3:
                argResults = _context2.sent;
                return _context2.abrupt("return", expr.apply(argResults));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function evalOperator(_x3, _x4) {
        return _evalOperator.apply(this, arguments);
      }

      return evalOperator;
    }()
  }, {
    key: "evalSpecialOperator",
    value: function () {
      var _evalSpecialOperator = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(expr, mapping) {
        var evaluate, context;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                evaluate = this.evaluate.bind(this);
                context = {
                  args: expr.args,
                  mapping: mapping,
                  evaluate: evaluate,
                  context: {
                    now: this.context.now,
                    baseIRI: this.context.baseIRI,
                    bnode: this.context.bnode
                  }
                };
                return _context3.abrupt("return", expr.applyAsync(context));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function evalSpecialOperator(_x5, _x6) {
        return _evalSpecialOperator.apply(this, arguments);
      }

      return evalSpecialOperator;
    }()
  }, {
    key: "evalNamed",
    value: function () {
      var _evalNamed = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(expr, mapping) {
        var _this2 = this;

        var argPromises, argResults;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                argPromises = expr.args.map(function (arg) {
                  return _this2.evaluate(arg, mapping);
                });
                _context4.next = 3;
                return Promise.all(argPromises);

              case 3:
                argResults = _context4.sent;
                return _context4.abrupt("return", expr.apply(argResults));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function evalNamed(_x7, _x8) {
        return _evalNamed.apply(this, arguments);
      }

      return evalNamed;
    }()
  }, {
    key: "evalExistence",
    value: function () {
      var _evalExistence = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(expr, mapping) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.context.exists) {
                  _context5.next = 2;
                  break;
                }

                throw new Err.NoExistenceHook();

              case 2:
                _context5.t0 = E.BooleanLiteral;
                _context5.next = 5;
                return this.context.exists(expr.expression, mapping);

              case 5:
                _context5.t1 = _context5.sent;
                return _context5.abrupt("return", new _context5.t0(_context5.t1));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function evalExistence(_x9, _x10) {
        return _evalExistence.apply(this, arguments);
      }

      return evalExistence;
    }() // TODO: Remove?

  }, {
    key: "evalAggregate",
    value: function () {
      var _evalAggregate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(expr, _mapping) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.context.aggregate) {
                  _context6.next = 2;
                  break;
                }

                throw new Err.NoExistenceHook();

              case 2:
                _context6.t0 = Transformation_1;
                _context6.next = 5;
                return this.context.aggregate(expr.expression);

              case 5:
                _context6.t1 = _context6.sent;
                return _context6.abrupt("return", _context6.t0.transformRDFTermUnsafe.call(_context6.t0, _context6.t1));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function evalAggregate(_x11, _x12) {
        return _evalAggregate.apply(this, arguments);
      }

      return evalAggregate;
    }()
  }]);

  return AsyncRecursiveEvaluator;
}();

exports.AsyncRecursiveEvaluator = AsyncRecursiveEvaluator;

var SyncRecursiveEvaluator =
/*#__PURE__*/
function () {
  function SyncRecursiveEvaluator(context) {
    var _this$subEvaluators2;

    _classCallCheck(this, SyncRecursiveEvaluator);

    this.context = context;
    this.subEvaluators = (_this$subEvaluators2 = {}, _defineProperty(_this$subEvaluators2, E.ExpressionType.Term, sharedEvaluators.term), _defineProperty(_this$subEvaluators2, E.ExpressionType.Variable, sharedEvaluators.variable), _defineProperty(_this$subEvaluators2, E.ExpressionType.Operator, this.evalOperator), _defineProperty(_this$subEvaluators2, E.ExpressionType.SpecialOperator, this.evalSpecialOperator), _defineProperty(_this$subEvaluators2, E.ExpressionType.Named, this.evalNamed), _defineProperty(_this$subEvaluators2, E.ExpressionType.Existence, this.evalExistence), _defineProperty(_this$subEvaluators2, E.ExpressionType.Aggregate, this.evalAggregate), _this$subEvaluators2);
  }

  _createClass(SyncRecursiveEvaluator, [{
    key: "evaluate",
    value: function evaluate(expr, mapping) {
      var evaluator = this.subEvaluators[expr.expressionType];

      if (!evaluator) {
        throw new Err.InvalidExpressionType(expr);
      }

      return evaluator.bind(this)(expr, mapping);
    }
  }, {
    key: "evalOperator",
    value: function evalOperator(expr, mapping) {
      var _this3 = this;

      var args = expr.args.map(function (arg) {
        return _this3.evaluate(arg, mapping);
      });
      return expr.apply(args);
    }
  }, {
    key: "evalSpecialOperator",
    value: function evalSpecialOperator(expr, mapping) {
      var evaluate = this.evaluate.bind(this);
      var context = {
        args: expr.args,
        mapping: mapping,
        evaluate: evaluate,
        context: {
          now: this.context.now,
          baseIRI: this.context.baseIRI,
          bnode: this.context.bnode
        }
      };
      return expr.applySync(context);
    }
  }, {
    key: "evalNamed",
    value: function evalNamed(expr, mapping) {
      var _this4 = this;

      var args = expr.args.map(function (arg) {
        return _this4.evaluate(arg, mapping);
      });
      return expr.apply(args);
    }
  }, {
    key: "evalExistence",
    value: function evalExistence(expr, mapping) {
      if (!this.context.exists) {
        throw new Err.NoExistenceHook();
      }

      return new E.BooleanLiteral(this.context.exists(expr.expression, mapping));
    }
  }, {
    key: "evalAggregate",
    value: function evalAggregate(expr, mapping) {
      if (!this.context.aggregate) {
        throw new Err.NoAggregator();
      }

      return Transformation_1.transformRDFTermUnsafe(this.context.aggregate(expr.expression));
    }
  }]);

  return SyncRecursiveEvaluator;
}();

exports.SyncRecursiveEvaluator = SyncRecursiveEvaluator;

var UnsupportedOperation =
/*#__PURE__*/
function (_Error) {
  _inherits(UnsupportedOperation, _Error);

  function UnsupportedOperation(operation) {
    _classCallCheck(this, UnsupportedOperation);

    return _possibleConstructorReturn(this, _getPrototypeOf(UnsupportedOperation).call(this, "Operation '".concat(operation, "' is unsupported in SimpleEvaluator")));
  }

  return UnsupportedOperation;
}(_wrapNativeSuper(Error));

exports.UnsupportedOperation = UnsupportedOperation;